/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EfsMelcoEfsModelsGlobalFormatListItem
 */
export interface EfsMelcoEfsModelsGlobalFormatListItem {
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsGlobalFormatListItem
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsGlobalFormatListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsGlobalFormatListItem
     */
    desc?: string | null;
}

export function EfsMelcoEfsModelsGlobalFormatListItemFromJSON(json: any): EfsMelcoEfsModelsGlobalFormatListItem {
    return EfsMelcoEfsModelsGlobalFormatListItemFromJSONTyped(json, false);
}

export function EfsMelcoEfsModelsGlobalFormatListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoEfsModelsGlobalFormatListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'desc': !exists(json, 'desc') ? undefined : json['desc'],
    };
}

export function EfsMelcoEfsModelsGlobalFormatListItemToJSON(value?: EfsMelcoEfsModelsGlobalFormatListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'name': value.name,
        'desc': value.desc,
    };
}


